import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-conection-failed',
  templateUrl: './conection-failed.component.html',
  styleUrls: ['./conection-failed.component.scss']
})
export class ConectionFailedComponent {
  constructor(private router:Router){

  }
  retry(){
    location.reload()
  }
}
